module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.d7c63908.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/font-awesome-4.6.3/fonts/fontawesome-webfont.svg?v=4.6.3
 ** module id = 1358
 ** module chunks = 0
 **/